import { render, staticRenderFns } from "./InvitationCompletion.vue?vue&type=template&id=bdb0f0f4&scoped=true&"
import script from "./InvitationCompletion.vue?vue&type=script&lang=ts&"
export * from "./InvitationCompletion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb0f0f4",
  null
  
)

export default component.exports